import { ReactNode } from 'react';
import {
  Alert as ChakraAlert,
  AlertDescription,
  AlertIcon,
  AlertProps as ChakraAlertProps,
  AlertStatus,
  AlertTitle,
  Box,
  CSSObject,
  CloseButton,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export interface AlertProps extends Omit<ChakraAlertProps, 'title'> {
  isOpen?: boolean;
  setIsOpen?: (arg0: boolean) => void;
  variant?: 'subtle' | 'solid' | 'left-accent' | 'top-accent';
  type: AlertStatus;
  title?: ReactNode;
  description?: ReactNode;
  showIcon?: boolean;
  chakraAlertProps?: CSSObject;
  iconProps?: CSSObject;
  detailsProps?: CSSObject;
  titleProps?: CSSObject;
  descriptionProps?: CSSObject;
  showCloseButton?: boolean;
  closeButtonProps?: CSSObject;
}

export const Alert = (props: AlertProps) => {
  const {
    isOpen = false,
    setIsOpen,
    variant = 'subtle',
    type,
    title,
    description,
    showIcon = true,
    showCloseButton = true,
    chakraAlertProps,
    iconProps,
    detailsProps,
    titleProps,
    descriptionProps,
    closeButtonProps,
    ...rest
  } = props;
  const styles = useMultiStyleConfig('Alert', props);

  return isOpen ? (
    <ChakraAlert
      status={type}
      variant={variant}
      sx={{ ...styles.ChakraAlert, ...chakraAlertProps }}
      {...rest}
    >
      {showIcon && <AlertIcon sx={{ ...styles.AlertIcon, ...iconProps }} />}
      <Box sx={{ ...styles.AlertContainer, ...detailsProps }}>
        <AlertTitle sx={{ ...styles.AlertTitle, ...titleProps }}>
          {title}
        </AlertTitle>
        <AlertDescription
          sx={{ ...styles.AlertDescription, ...descriptionProps }}
        >
          {description}
        </AlertDescription>
      </Box>
      {showCloseButton && (
        <CloseButton
          sx={{ ...styles.CloseButton, ...closeButtonProps }}
          onClick={() => setIsOpen && setIsOpen(false)}
        />
      )}
    </ChakraAlert>
  ) : (
    <></>
  );
};
